<template>
  <div>
    <List>
      <ListItem><Button type="dashed" icon="ios-add" long @click="NewBuildHandleClick">新增</Button></ListItem>
      <ListItem v-for="item of lists" :key="item.Help_ID" >
        <ListItemMeta
          :title="item.question"
          :description="item.answer"
        />
        <template slot="action">
          <li>
            <Button type="primary" shape="circle" icon="ios-create-outline" @click="EditHandleClick(item)">编辑</Button>
          </li>
          <li>
            <Poptip
            confirm
            title="你确定要删除这个客服信息吗?"
            @on-ok="DeleteHandleClick(item)"
          >
              <Button type="error"  icon="ios-trash-outline">删除</Button>
            </Poptip>
          </li>
        </template>
      </ListItem>
    </List>

    <!-- 抽屉 -->
     <span></span>
      <Drawer title="帮助中心信息维护" v-model="isDrawer" width="80" :mask-closable="false">
        <Form  :model="infoback" ref="formCustom" :rules="ruleCustom">
          <FormItem label="问题" label-position="top" prop="question">
                <Input  v-model="infoback.question" value="infoback.question" maxlength="100" show-word-limit type="textarea"/>
          </FormItem>
          <FormItem label="回答" label-position="top" prop="answer">
                <Input  v-model="infoback.answer" value="infoback.answer" maxlength="200" show-word-limit type="textarea"/>
          </FormItem>
        </Form>
        <div class="demo-drawer-footer">
          <Button style="margin-right: 8px" @click="CancelHandleClick">取消</Button>
          <Button type="primary" @click="SubmitHandleClick('formCustom')">提交</Button>
        </div>
      </Drawer>
  </div>
</template>

<script>
import { HelpCenter, ChangeHelpCenter } from '../../../api/Customer'
export default {
  name: 'HelpCenter',
  data () {
    const validatequestion = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写问题'))
      }
      callback()
    }
    const validateanswer = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写回答'))
      }
      callback()
    }
    return {
      lists: [],
      info: {
        Help_ID: '',
        question: '',
        answer: ''
      },
      infoback: {
        Help_ID: '',
        question: '',
        answer: ''
      },
      State: 0,
      isDrawer: false,
      ruleCustom: {
        question: [{ validator: validatequestion, trigger: 'blur' }],
        answer: [{ validator: validateanswer, trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    this.GetHelpCenter()
  },
  methods: {
    // 获取帮助中心数据
    GetHelpCenter () {
      HelpCenter().then(res => {
        if (res.IsSuccess) {
          this.lists = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 点击新增按钮回调事件
    NewBuildHandleClick () {
      this.State = 0
      this.infoback = {
        Help_ID: '',
        question: '',
        answer: ''
      }
      this.isDrawer = true
    },
    // 点击编辑按钮回调事件
    EditHandleClick (item) {
      this.State = 1
      this.infoback = item
      this.isDrawer = true
    },
    // 点击删除按钮回调事件
    DeleteHandleClick (item) {
      this.State = 2
      this.infoback = item
      this.OkHandleClick()
    },
    // 弹窗的取消按钮回调
    CancelHandleClick () {
      this.isDrawer = false
    },
    // 弹窗的提交按钮回调
    SubmitHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.OkHandleClick()
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    // 提交帮助中心信息接口数据
    OkHandleClick () {
      ChangeHelpCenter({
        Help_ID: this.infoback.Help_ID,
        question: this.infoback.question,
        answer: this.infoback.answer,
        operation: this.State
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.GetHelpCenter()
          this.isDrawer = false
        } else {
          this.$Message.error(res.Message)
        }
      })
    }
  }
}
</script>
